export default class LoginSystemModel {
  constructor(data) {
    this.user = data && data.user ? data.user : ''
    this.password = data && data.password ? data.password : ''
  }
}
